import React from "react";

import styled from "styled-components";
import { Title } from "../common/Title";
import theme from "../../theme";
import sun from "../../image/sun.svg";
import clock from "../../image/clock.svg";
import CommonContainer from "../common/CommonContainer";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setWorkType } from "../../modules/form";

const CareTypeSelection = (props) => {
  const selectColor = theme.colors.orange;

  const { workType } = useSelector((state) => ({
    workType: state.form.workType,
  }));

  const dispatch = useDispatch();
  const history = useNavigate();
  const handleSetWorkType = (workType) => dispatch(setWorkType(workType));

  const handleNextClick = () => {
    history("/schedule");
  };
  return (
    <CommonContainer
      button
      disabled={workType ? false : true}
      handleNextClick={handleNextClick}
    >
      {/* <Header button/> */}
      <Container selectColor={selectColor}>
        <SizeBox styleHeight={"2rem"} />
        <Title
          title={"돌봄 유형"}
          description={"돌봄 유형을 설정해주세요"}
          progressNum={1}
        />
        <SizeBox styleHeight={"2rem"} />
        <SelectBox>
          <SelelctElement
            className={`${workType === "DAY" ? "active" : ""}`}
            onClick={() => handleSetWorkType("DAY")}
          >
            <ImageBox>
              <img src={sun} alt="" />
            </ImageBox>
            <SizeBox styleHeight={"0.5rem"} />
            <div>24시간 상주</div>
          </SelelctElement>
          <SelelctElement
            className={`${workType === "TIME" ? "active" : ""}`}
            onClick={() => handleSetWorkType("TIME")}
          >
            <ImageBox>
              <img src={clock} alt="" />
            </ImageBox>
            <SizeBox styleHeight={"0.5rem"} />
            <div>시간제 돌봄</div>
          </SelelctElement>
        </SelectBox>
      </Container>
      {/* <Footer disabled={workType ? false : true} nextLink={'/schedule'}/> */}
    </CommonContainer>
  );
};

export default CareTypeSelection;

const Container = styled.div`
  width: 100%;
  height: 39.875rem;
  box-sizing: border-box;
  padding: 0 16px;
  font-family: "SpoqaHanSansNeoRegular";
  font-size: 14px;
  font-weight: 700;

  .active {
    background-color: ${(props) => props.selectColor};
    color: #ffffff;
  }
`;
const SizeBox = styled.div`
  width: 100%;
  height: ${(props) => props.styleHeight};
`;

const SelectBox = styled.div`
  width: 100%;
  min-height: 144px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ImageBox = styled.div`
  width: 3rem;
  height: 4.25rem;
  display: flex;
`;

const SelelctElement = styled.div`
  width: 10rem;
  height: 9rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #eeeeee;
  border-radius: 4px;
`;
